// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"0aa55803c3947672ac30","655":"e294e0bbeec2e4756719"}[chunkId] + ".js";
};